// POST请求
import Axios from 'plugins/axios.js';

// 登录api
export function LoginApi(data) {
  return Axios({
    url:'/v1/login',
    method:'post',
    data
  });
}
// 退出登录api
export function LoginOut(data) {
  return Axios({
    url:'/v1/member/logout',
    method:'post',
    data
  });
}

// 图片及gif图上传  在upload组件中引用失效
export function uploadApi(url,formdata){
  return Axios({
    url:url,
    method:'post',
    formdata
  });
}


// pc----API

export function initBannerList(data) {
  return Axios({
    url: '/v1/banner/list',
    method: 'post',
    data
  });
}

export function findBanners(data) {
  return Axios({
    url: '/v1/banner/find',
    method: 'post',
    data
  });
}

export function saveBanners(data) {
  return Axios({
    url: '/v1/banner/save',
    method: 'post',
    data
  });
}
export function deleteBanners(data) {
  return Axios({
    url: '/v1/banner/delete',
    method: 'post',
    data
  });
}
// ***********
export function initEventList(data) {
  return Axios({
    url: '/v1/match/list',
    method: 'post',
    data
  });
}

export function findEvents(data) {
  return Axios({
    url: '/v1/match/find',
    method: 'post',
    data
  });
}
export function saveEvents(data) {
  return Axios({
    url: '/v1/match/save',
    method: 'post',
    data
  });
}
export function deleteEvents(data) {
  return Axios({
    url: '/v1/match/delete',
    method: 'post',
    data
  });
}
// *************
export function initPlanList(data) {
  return Axios({
    url: '/v1/courseware/list',
    method: 'post',
    data
  });
}

export function initPostList(data) {
  return Axios({
    url: '/v1/courseware/poslist',
    method: 'post',
    data
  });
}


export function savePlans(data) {
  return Axios({
    url: '/v1/courseware/save',
    method: 'post',
    data
  });
}

export function findPlans(data) {
  return Axios({
    url: '/v1/courseware/find',
    method: 'post',
    data
  });
}

export function deletePlans(data) {
  return Axios({
    url: '/v1/courseware/delete',
    method: 'post',
    data
  });
}


// *************
export function ininGifList(data) {
  return Axios({
    url: '/v1/coursewaregif/list',
    method: 'post',
    data
  });
}
export function findGifs(data) {
  return Axios({
    url: '/v1/coursewaregif/find',
    method: 'post',
    data
  });
}
export function saveGifs(data) {
  return Axios({
    url: '/v1/coursewaregif/save',
    method: 'post',
    data
  });
}
export function deleteGifs(data) {
  return Axios({
    url: '/v1/coursewaregif/delete',
    method: 'post',
    data
  });
}



// *****************

export function initCoursList(data) {
  return Axios({
    url: '/v1/coursewareplate/list',
    method: 'post',
    data
  });
}

export function findCours(data) {
  return Axios({
    url: '/v1/coursewareplate/find',
    method: 'post',
    data
  });
}
export function saveCours(data) {
  return Axios({
    url: '/v1/coursewareplate/save',
    method: 'post',
    data
  });
}

export function initCategoryList(data) {
  return Axios({
    url: '/v1/coursewarecategory/list',
    method: 'post',
    data
  });
}

export function findCategory(data) {
  return Axios({
    url: '/v1/coursewarecategory/find',
    method: 'post',
    data
  });
}

export function saveCategory(data) {
  return Axios({
    url: '/v1/coursewarecategory/save',
    method: 'post',
    data
  });
}

// ****************

export function initStudentList(data){
  return Axios({
    url:'/v1/student/list',
    method:'post',
    data
  });
}
// 三级科目列表
export function initCoursThreeList(data){
  return Axios({
    url:'/v1/courseware/list',
    method:'post',
    data
  });
}
export function findStudents(data){
  return Axios({
    url:'/v1/student/find',
    method:'post',
    data
  });
}
export function saveStudents(data){
  return Axios({
    url:'/v1/student/save',
    method:'post',
    data
  });
}
// ****************

export function initTeacherList(data){
  return Axios({
    url:'/v1/teacher/list',
    method:'post',
    data
  });
}

export function findTeachers(data){
  return Axios({
    url:'/v1/teacher/find',
    method:'post',
    data
  });
}
export function saveTeachers(data){
  return Axios({
    url:'/v1/teacher/save',
    method:'post',
    data
  });
}
export function deleteTeatchers(data){
  return Axios({
    url:'/v1/teacher/delete',
    method:'post',
    data
  });
}


// oj----API

// 题目**************
export function initFicationList(data){
  return Axios({
    url:'/v1/category/list',
    method:'post',
    data
  });
}

export function initLimitList(data){
  return Axios({
    url:'/v1/category/limit',
    method:'post',
    data
  });
}

export function findFications(data){
  return Axios({
    url:'/v1/category/find',
    method:'post',
    data
  });
}

export function saveFications(data){
  return Axios({
    url:'/v1/category/save',
    method:'post',
    data
  });
}

export function createFications(data){
  return Axios({
    url:'/v1/category/create',
    method:'post',
    data
  });
}

export function deleteFications(data){
  return Axios({
    url:'/v1/category/delete',
    method:'post',
    data
  });
}


// 竞赛******************

export function initMatchList(api,data){
  return Axios({
    url:api,
    method:'post',
    data
  });
}


export function initLanguageList(){
  return Axios({
    url:'/v1/language',
    method:'post'
  });
}

export function findContests(data){
  return Axios({
    url:'/v1/contest/edit',
    method:'post',
    data
  });
}

export function saveContests(api,data){
  return Axios({
    url:api,
    method:'post',
    data
  });
}

export function deleteContests(data){
  return Axios({
    url:'/v1/contest/delete',
    method:'post',
    data
  });
}

export function addContests(data){
  return Axios({
    url:'/v1/contest/add',
    method:'post',
    data
  });
}

export function changeContestDefunct(data){
  return Axios({
    url:'/v1/contest/defunct',
    method:'post',
    data
  });
}

export function downloadLogs(data){
  return Axios({
    url:'/v1/contest/logs',
    method:'post',
    data
  });
}

// 题单***********
export function initQuesList(api,data){
  return Axios({
    url:api,
    method:'post',
    data
  });
}
export function findQuesList(data){
  return Axios({
    url:'/v1/problemGroup/find',
    method:'post',
    data
  });
}

export function saveQuesList(data){
  return Axios({
    url:'/v1/problemGroup/save',
    method:'post',
    data
  });
}

export function deleteQuesList(data){
  return Axios({
    url:'/v1/problemGroup/delete',
    method:'post',
    data
  });
}

export function addQuesList(data){
  return Axios({
    url:'/v1/problemGroup/save',
    method:'post',
    data
  });
}

export function changeQuesListDefunct(data){
  return Axios({
    url:'/v1/problemGroup/defunct',
    method:'post',
    data
  });
}


// 公告***********

export function initNewsList(){
  return Axios({
    url:'/v1/news/list',
    method:'post'
  });
}

export function findNews(data){
  return Axios({
    url:'/v1/news/find',
    method:'post',
    data
  });
}

export function saveNews(data){
  return Axios({
    url:'/v1/news/save',
    method:'post',
    data
  });
}

export function deleteNews(data){
  return Axios({
    url:'/v1/news/delete',
    method:'post',
    data
  });
}

export function addNews(data){
  return Axios({
    url:'/v1/news/add',
    method:'post',
    data
  });
}

export function changeNewsDefunct(data){
  return Axios({
    url:'/v1/news/defunct',
    method:'post',
    data
  });
}

// 权限*************
export function initPrivilegeList(data){
  return Axios({
    url:'/v1/privilege/list',
    method:'post',
    data
  });
}

export function initRightList(){
  return Axios({
    url:'/v1/privilege/right',
    method:'post'
  });
}

export function deleteLimits(data){
  return Axios({
    url:'/v1/privilege/delete',
    method:'post',
    data
  });
}

export function initOrderList(data){
  return Axios({
    url:'/v1/privilege/right',
    method:'post',
    data
  });
}
export function addEditorPrivilege(data){
  return Axios({
    url:'/v1/privilege/add',
    method:'post',
    data
  });
}


export function initUsersList(data){
  return Axios({
    url:'/v1/users/list',
    method:'post',
    data
  });
}

export function changeUsersDefunct(data){
  return Axios({
    url:'/v1/users/defunct',
    method:'post',
    data
  });
}

// 题目**********
export function initProblemsList(api,data){
  return Axios({
    url:api,
    method:'post',
    data
  });
}

export function initProblemSurce(data){
  return Axios({
    url:'/v1/problem/source',
    method:'post',
    data
  });
}

export function findProblems(data){
  return Axios({
    url:'/v1/problem/find',
    method:'post',
    data
  });
}

export function saveProblems(data){
  return Axios({
    url:'/v1/problem/save',
    method:'post',
    data
  });
}

export function deleteProblems(data){
  return Axios({
    url:'/v1/problem/delete',
    method:'post',
    data
  });
}

export function addProblems(data){
  return Axios({
    url:'/v1/problem/add',
    method:'post',
    data
  });
}

export function changeProblemDefunct(data){
  return Axios({
    url:'/v1/problem/defunct',
    method:'post',
    data
  });
}

// 测试点************

export function initTestPointList(data){
  return Axios({
    url:'/v1/test/list',
    method:'post',
    data
  });
}

export function deleteTestPoints(data){
  return Axios({
    url:'/v1/test/delete',
    method:'post',
    data
  });
}

export function downloadTestPoints(data){
  return Axios({
    url:'/v1/test/file',
    method:'post',
    data
  });
}

export function createTestPoints(data){
  return Axios({
    url:'/v1/test/create',
    method:'post',
    data
  });
}

export function renameTestPoints(data){
  return Axios({
    url:'/v1/test/rename',
    method:'post',
    data
  });
}

export function editTestPoints(data){
  return Axios({
    url:'/v1/test/edit',
    method:'post',
    data
  });
}

export function saveTestPoints(data){
  return Axios({
    url:'/v1/test/save',
    method:'post',
    data
  });
}